import { createAsyncThunk } from "@reduxjs/toolkit";
import { ProjectItem } from "../../types/interface";
import {
  PROJECT_ADD_PROJECTS,
  PROJECT_EDIT_PROJECTS,
  PROJECT_FETCH_PROJECTS,
  PROJECT_TOGGLE_PROJECTS,
} from "../../constants";
import AxiosInstance from "../../Service/AxiosInstance";
import sampleImage1 from "../../assets/img/sample-project-1.png";
import sampleImage2 from "../../assets/img/sample-project-2.png";
import sampleImage3 from "../../assets/img/sample-project-3.png";

const baseURL = `${process.env.REACT_APP_SERVER_BASEURL}`;

    // Hardcoded sample projects
    const sampleProjects: ProjectItem[] = [
      {
        id: "sample-project",
        labels: 2,
        images: 78,
        annotations: 115,
        annotatedImageCount: 0,
        models: 0,
        imageUrl: "",
        thubmImageUrl: sampleImage1,
        name: "Helmet Detection",
        description: "This is a sample project description",
        taskTypeId: "d1276b96-3735-4181-8b9b-ffe9fcd5fe82",
        domainTypeId: "sample-domain-type-1",
        createdDate: "2025-01-01T10:00:00",
        customerId: "sample-customer-id-1",
        liked: true,
        colour: "#cdf4dd",
        isSample: true,
        isNotDownload: true,
      },
      {
        id: "sample-project",
        labels: 2,
        images: 40,
        annotations: 466,
        annotatedImageCount: 0,
        models: 0,
        imageUrl: "",
        thubmImageUrl: sampleImage2,
        name: "Fastners Count",
        description: "Another sample project",
        taskTypeId: "4577f6ce-b2b0-4cb6-9b55-c3968dc9f5b3",
        domainTypeId: "sample-domain-type-2",
        createdDate: "2025-01-02T12:00:00",
        customerId: "sample-customer-id-2",
        liked: false,
        colour: "#E2D0F7",
        isSample: true,
        isNotDownload: true,
      },
      {
        id: "sample-project",
        labels: 1,
        images: 46,
        annotations: 140,
        annotatedImageCount: 0,
        models: 0,
        imageUrl: "",
        thubmImageUrl: sampleImage3,
        name: "Fuse Detection",
        description: "Yet another sample project",
        taskTypeId: "d1276b96-3735-4181-8b9b-ffe9fcd5fe82",
        domainTypeId: "sample-domain-type-3",
        createdDate: "2025-01-03T15:00:00",
        customerId: "sample-customer-id-3",
        liked: true,
        colour: "#cdf4dd",
        isSample: true,
        isNotDownload: true,
      },
    ];

export const fetchProjects = createAsyncThunk(
  PROJECT_FETCH_PROJECTS,
  async () => {
    const response = await AxiosInstance.get(
      `${baseURL}/api/Project/GetAllCount`
    );

    // Cast API response to correct type
    const projectsFromAPI: ProjectItem[] = response.data;

    // Remove sample projects if they already exist in API response
    const filteredSampleProjects = sampleProjects.filter(
      (sample) =>
        !projectsFromAPI.some(
          (apiProject: ProjectItem) => apiProject.name === sample.name
        )
    );

    // Combine API response and filtered sample projects
    const allProjects = [...filteredSampleProjects, ...projectsFromAPI];

    return allProjects;
  }
);

export const fetchProjectById = createAsyncThunk(
  "project/fetchById",
  async (id: string) => {
    const response = await AxiosInstance.get(
      `${baseURL}/api/Project/GetById?projectId=` + id
    );

    return response.data;
  }
);

export const addProject = createAsyncThunk(
  PROJECT_ADD_PROJECTS,
  async (newProject: ProjectItem) => {
    const response = await AxiosInstance.post(baseURL, newProject);
    return response.data;
  }
);

export const editProject = createAsyncThunk(
  PROJECT_EDIT_PROJECTS,
  async ({
    id,
    updatedData,
  }: {
    id: number;
    updatedData: Partial<ProjectItem>;
  }) => {
    const response = await AxiosInstance.patch(`${baseURL}/${id}`, updatedData);
    return { id, updatedData: response.data };
  }
);

export const toggleLike = createAsyncThunk(
  PROJECT_TOGGLE_PROJECTS,
  async (id: number) => {
    const response = await AxiosInstance.patch(`${baseURL}/${id}/toggle-like`);
    return response.data;
  }
);
